import React from 'react';
import MenuPainel from '../components/MenuPainel';
import Historico from '../components/Historicoedit';
import { ChangePassword } from '../components/ChangePassword';
import PaperForm from '../components/PaperForm';
import GlobalStyle from '../styles/globalStyle';
import { CssBaseline } from '@material-ui/core';
class Historicoedit extends React.Component {
  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <GlobalStyle />
        <ChangePassword />
        <MenuPainel>
          <PaperForm
            title={''}
            margin={'15px 0'}
            elevation={24}
            componente={<Historico />}
          ></PaperForm>
        </MenuPainel>
      </React.Fragment>
    );
  }
}

const connectedAssinar = Historicoedit;
export { connectedAssinar as Historicoedit };
